import { observer } from 'mobx-react-lite';
import { Gauge } from '@phosphor-icons/react';
import { useResolve } from '@/infrastructure/useResolve';
import { useT } from './useT';
import { TOKEN_SettingsStore } from './SettingsStore';

const inputCls =
  'w-24 border border-steel-300 bg-white px-2 py-1 font-mono text-sm dark:border-steel-700 dark:bg-steel-800';

export const SettingsView = observer(function SettingsView() {
  const s = useResolve(TOKEN_SettingsStore);
  const t = useT();
  return (
    <div className="border-l-4 border-steel-400 bg-white p-3 shadow-sm dark:bg-steel-900">
      <header className="mb-3 flex items-center gap-2 font-mono text-xs font-bold tracking-wider text-steel-700 dark:text-steel-200">
        <Gauge weight="fill" size={16} />
        {t.setup.parametersHeader}
      </header>
      <div className="flex flex-wrap items-end gap-5">
        <label className="flex flex-col gap-1">
          <span className="font-mono text-[10px] uppercase tracking-wider text-steel-500">
            {t.setup.horizonDays}
          </span>
          <input
            type="number"
            min={7}
            max={730}
            value={s.horizonDays}
            onChange={(e) => s.setHorizonDays(Number(e.target.value))}
            className={inputCls}
          />
        </label>
        <label className="flex flex-col gap-1">
          <span className="font-mono text-[10px] uppercase tracking-wider text-steel-500">
            {t.setup.purchaseLeadDays}
          </span>
          <input
            type="number"
            min={0}
            value={s.defaultPurchaseLeadDays}
            onChange={(e) => s.setDefaultPurchaseLeadDays(Number(e.target.value))}
            className={inputCls}
          />
        </label>
        <label className="flex flex-col gap-1">
          <span className="font-mono text-[10px] uppercase tracking-wider text-steel-500">
            {t.setup.productionLeadDays}
          </span>
          <input
            type="number"
            min={0}
            value={s.defaultProductionLeadDays}
            onChange={(e) => s.setDefaultProductionLeadDays(Number(e.target.value))}
            className={inputCls}
          />
        </label>
        <label className="flex flex-col gap-1">
          <span className="font-mono text-[10px] uppercase tracking-wider text-steel-500">
            {t.setup.safetyStockPercent}
          </span>
          <input
            type="number"
            min={0}
            max={100}
            value={Math.round(s.safetyStockPercent * 100)}
            onChange={(e) => s.setSafetyStockPercent(Number(e.target.value) / 100)}
            className="w-20 border border-steel-300 bg-white px-2 py-1 font-mono text-sm dark:border-steel-700 dark:bg-steel-800"
          />
        </label>
      </div>
    </div>
  );
});
